<div class="popup-backdrop">
  <div class="popup-container">
    <div class="header-container">
      <div class="picker-header">
        <span>{{title}}</span>
        <button class="close-btn" (click)="close()" id="btnClose">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 22 22" fill="none">
            <path fill="currentColor"
              d="M13.2745 11L16.686 7.58852C17.1047 7.16989 17.1047 6.49114 16.686 6.07216L15.9278 5.31398C15.5092 4.89534 14.8305 4.89534 14.4115 5.31398L11 8.72545L7.58852 5.31398C7.16989 4.89534 6.49114 4.89534 6.07216 5.31398L5.31398 6.07216C4.89534 6.4908 4.89534 7.16955 5.31398 7.58852L8.72545 11L5.31398 14.4115C4.89534 14.8301 4.89534 15.5089 5.31398 15.9278L6.07216 16.686C6.4908 17.1047 7.16989 17.1047 7.58852 16.686L11 13.2745L14.4115 16.686C14.8301 17.1047 15.5092 17.1047 15.9278 16.686L16.686 15.9278C17.1047 15.5092 17.1047 14.8305 16.686 14.4115L13.2745 11Z"
              fill="currentColor" />
          </svg>
        </button>
      </div>

      <div class="search-input-wrapper">
        <div class="search-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="currentColor"
              d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
          </svg>
        </div>
        <input type="text" class="search-input" [placeholder]="placeholder" [(ngModel)]="searchTerm"
          (input)="filterValues()" />
      </div>
    </div>

    <div class="list">
      @for (item of filteredValues; track item) {
        <div class="list-item" (click)="selectValue(item[key])"
          [ngClass]="{'selected-value': item[key] == selectedValue}">
          {{ item[key] }}
        </div>
      }
    </div>
  </div>
</div>